import { inject, Injectable } from "@angular/core";
import { AUTHENTICATION_TIMEOUT_MILLIS } from "@config";
import { environment } from "@environments/environment";
import { AnalyticsService } from "@services/analytics.service";
import { AuthenticationService } from "@services/authentication.service";

@Injectable({
  providedIn: "root",
})
export class MessagingService {
  protected authenticationService = inject(AuthenticationService);
  private analyticsService = inject(AnalyticsService);

  private parentOrigin = environment.iframeConfig.parentOrigin;
  private messageTimerId: number | undefined = undefined;

  sendIframeReadyMessage(): void {
    if (window.parent) {
      window.parent.postMessage({ type: "iframe-ready" }, this.parentOrigin);
      this.messageTimerId = setTimeout(this.handleIframeMessageTimeout.bind(this), AUTHENTICATION_TIMEOUT_MILLIS);
    }
  }

  sendAccountSettingsMessage(): void {
    window.open(`${this.parentOrigin}/fr/parametres`, "_blank");
  }

  sendLogoutMessage(): void {
    window.parent.postMessage({ type: "logout-message" }, this.parentOrigin);
    this.authenticationService.signUserOut().then(() => window.location.reload());
  }

  sendLoginMessage(): void {
    window.parent.postMessage({ type: "login-message" }, this.parentOrigin);
  }

  sendSignupMessage(): void {
    window.parent.postMessage({ type: "signup-message" }, this.parentOrigin);
  }

  async handleIframeMessageReception(event: MessageEvent) {
    if (event.data?.type === "auth-message") {
      this.handleAuthMessage(event);
      clearTimeout(this.messageTimerId);
    } else if (event.data?.type === "logout-message") {
      this.authenticationService.signUserOut();
    }
  }

  private handleIframeMessageTimeout() {
    if (this.authenticationService.isAuthenticating()) {
      this.analyticsService.trackException(
        new Error("No message of type 'auth-message' was received from parent application. The current user will be considered as a guest.")
      );
      this.authenticationService.setUserAsGuest();
      this.authenticationService.isAuthenticating.set(false);
    }
  }

  private handleAuthMessage(event: MessageEvent) {
    if (event.data.isGuest) {
      this.authenticationService.setUserAsGuest();
    } else {
      this.authenticationService.authenticateUser(event.data?.token);
    }
  }
}
